// Installment amount of a reassurance line ("- soit 3 fois 29,67 €"): switches to the amount of the selected variant.
class Installments extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init = () => {
    this.amounts = new Map(
      (this.dataset.amounts || '')
        .split(';;')
        .filter(Boolean)
        .map((entry) => entry.split('|'))
    );

    document.addEventListener('variant:change', this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:change', this.handleVariantChange);
  }

  handleVariantChange = (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    const label = this.amounts.get(String(variant.id));
    if (label) this.textContent = label;
  }
}

if (!customElements.get('wq-installments')) {
  customElements.define('wq-installments', Installments);
}
